import { render } from "./LinkDetail.vue?vue&type=template&id=1b00154a&scoped=true"
import script from "./LinkDetail.vue?vue&type=script&lang=js"
export * from "./LinkDetail.vue?vue&type=script&lang=js"

import "./LinkDetail.vue?vue&type=style&index=0&id=1b00154a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b00154a"]])

export default __exports__